import { Component } from '@angular/core';

@Component({
    selector: 'app-dialog-dynamic',
    templateUrl: './dialog-dynamic.component.html',
    styleUrls: ['./dialog-dynamic.component.scss'],
})
export class DialogDynamicComponent {}
